package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.AnnotatedString
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServicesReorderDialog(
    title: String,
    message: AnnotatedString,
    isVisible: Boolean,
    onConfirm: () -> Unit,
    onDismissRequest: () -> Unit,
) {
    if (isVisible) {
        EsDialog(
            title = title,
            onDismissRequest = onDismissRequest,
            modifier = Modifier.padding(16.dp),
        ) {
            Column(
                modifier = Modifier
                    .padding(16.dp)
            ) {
                Text(
                    text = message,
                    color = esColorScheme.textSecondary,
                    style = esTypography.p2Regular14,
                    modifier = Modifier
                        .fillMaxWidth()
                )

                Spacer(modifier = Modifier.padding(20.dp))

                Row(
                    horizontalArrangement = Arrangement.spacedBy(16.dp),
                    modifier = Modifier.fillMaxWidth(),
                ) {
                    EsLargePrimaryButton(
                        onClick = {
                            onConfirm()
                            onDismissRequest()
                        },
                        text = "Confirm",
                        modifier = Modifier.weight(1f),
                    )

                    EsLargeSecondaryButton(
                        onClick = onDismissRequest,
                        text = "Cancel",
                        modifier = Modifier.weight(1f),
                    )
                }
            }
        }
    }
}